import { ListFilters } from 'shared/_components/list/types';
import { DocType } from 'shared/constants/docs';
import { LIST_PAGE_SIZE, LIST_SORT_BY } from 'shared/_components/list/constants';

type GetListOptionsProps = Partial<ListFilters> & {
	filters?: ListFilters['options']['selector'][string];
	type: DocType,
};

export function getListOptions(props: GetListOptionsProps): ListFilters {
	const {
		type,
		limit = LIST_PAGE_SIZE,
		sortBy = LIST_SORT_BY,
		filters = [],
	} = props;
	const { options = { selector: { $and: [{ type: { $eq: type } }] } } } = props;

	return {
		startId: null,
		limit,
		sortBy,
		options: {
			...options,
			selector: {
				...options?.selector,
				$and: [
					...options?.selector?.$and,
					...filters,
				],
			},
		},
	};
}
